import {getInitParam, InitParam, Line2, MPos, PlaceMeta, SegmentLine, Vec2} from "@3dcalc/3dpClient";

const mapVec2: Vec2[] = []
const line2: Line2 = [[0, 0], [0, 0]]
const mapVec3: MPos[] = []
const segmentLines: SegmentLine[] = []
const placeMeta: PlaceMeta = { h: 0, l: 0, p: { b: [0, 0], t: [0, 0] }, w: 0 }

type ReadyCallback = () => void
const callbacks: ReadyCallback[] = []

type CarportInitParam = InitParam & {
    e: { left: number; right: number; front: number; back: number }
}

export let isReady = false

export let initParam: CarportInitParam = {
    ...getInitParam(),
    e: { left: 0, right: 0, front: 0, back: 0 },
}

export function onReady(cb: ReadyCallback) {
    if (isReady) cb()
    else callbacks.push(cb)
}

export function setReady(config: InitParam) {
    Object.assign(initParam, config)
    isReady = true
    callbacks.forEach(cb => cb())
    callbacks.length = 0
}

export const CP = {
    maps: {
        pillar: {
            line: mapVec2,
            map: mapVec3,
            lineCenteredCut: mapVec2,
            lineCut: mapVec2,
            lineCentered: mapVec2
        },
        f1: {
            lineCut: mapVec2,
        },
        harness: {
            segments: segmentLines,
        },
        f2: {
            param: placeMeta,
        },
        f3: {
            diagonal: line2,
        },
        f4: {
            point: [0, 0]
        },
        f6: {
            point: [0, 0]
        },
        rafter: {
            lineCut: mapVec2,
            map: mapVec2,
            hGash: 0,
            l: {
                left: 0,
                right: 0,
            },
            shiftBottom: {
                left: 0,
                right: 0,
            },
            hCut: 0,
            mapCentered: mapVec2
        }
    },
    gash: {
        simple: 0.02,
        cut: 0.05,
        rafterAngle: 0,
    },
}

export function initializate() {
    initParam.gash.cut = initParam.elementData.harness.sizeBoard.w - initParam.elementData.pillar.sizeBoard.h / 2
}
